import { createContext, useContext } from "react";

const PhotoContext = createContext({});

export function PhotoProvider({ value, children }) {
  return <PhotoContext.Provider value={value}>{children}</PhotoContext.Provider>;
}

export function usePhotoUrl(id) {
  const map = useContext(PhotoContext);
  return map[id] || null;
}
